import React, {useState} from 'react';

import {Link} from 'react-router';

import {StyledFooterDIV} from 'app/general/structures/DocSidebarPagePanels';
import {AssignNewTaskModal} from 'app/tasks/components/AssignTaskModal';
import {gt} from 'app/utils/i18n';

import type {TaskAssignableContentTypes} from 'sweet-types';

interface Props {
  objectId: number;
  html_url: string;
  contentType: TaskAssignableContentTypes;
  canAssign: boolean;
  onAssign: () => unknown;
}

export function DetailPageRelatedTasksSidebarFooter({
  objectId,
  contentType,
  canAssign,
  html_url,
  onAssign,
}: Props): JSX.Element {
  const [showModal, setShowModal] = useState(false);

  return (
    <StyledFooterDIV>
      <Link
        to={`${html_url}tasks/report/`}
        className="btn btn-outline-secondary btn-sm btn-block"
      >
        <i className="fas fa-file-chart-line" /> {gt('Task Overview')}
      </Link>
      {canAssign ? (
        <>
          <button
            className="btn btn-secondary btn-sm btn-block"
            onClick={() => setShowModal(true)}
          >
            <i className="fa fa-plus-circle" /> {gt('Assign Task')}
          </button>
          <AssignNewTaskModal
            show={showModal}
            onToggle={() => setShowModal(false)}
            onAssignSuccess={onAssign}
            taskData={{
              content_type: contentType,
              object_id: objectId,
            }}
          />
        </>
      ) : null}
    </StyledFooterDIV>
  );
}
